<div id="id{{ name }}" class="main {{ userClass }}">
  <div
    *ngIf="testHasValue()"
    [class.haserror-gotop]="isshow && group?.controls[name]?.touched && group?.controls[name]?.invalid"
    [class.gotop]="isshow || labletop"
    [class.hideborder]="hideBorder"
    (focus)="focusFunction($event)"
    (click)="focusFunction($event); inp.click()"
    (focusout)="focusOutFunction($event)"
    class="label">
    <label
      class="txt"
      [class.lbl]="isshow || labletop"
      [class.error]="name && group?.controls[name] && group?.controls[name]?.touched && group?.controls[name]?.invalid">
      {{ label }}
    </label>
    <span
      class="star"
      [class.error]="name && group?.controls[name] && group?.controls[name]?.touched && group?.controls[name]?.invalid"
      *ngIf="required === true">
      *
    </span>
  </div>
  <div class="inputbox" (click)="$event.stopPropagation()">
    <input
      #inp
      [SsgMask]="inputMask"
      sepidzAutoFocus
      currency
      [(ngModel)]="inputDataModel.currentValue"
      (focus)="focusFunction($event)"
      (focusout)="focusOutFunction($event)"
      (change)="changeEvent($event)"
      (keydown.enter)="onEnterKeyDown($event)"
      tabindex="{{ tabOrder }}"
      [attr.inputmode]="inputMode"
      (keypress)="numberOnly($event)"
      class="textinput"
      [class.hideborder]="hideBorder"
      [class.hasborder]="isshow || labletop"
      [class.border]="isshow || labletop"
      [class.showErrorBorder]="group?.controls[name]?.touched && group?.controls[name]?.invalid && !inputFocus"
      [class.readonlyvisible]="isReadOnly"
      type="{{ textType }}"
      id="{{ name }}"
      [(ngClass)]="class"
      name="{{ name }}"
      [disabled]="disabled"
      [placeholder]="placeholder"
      numbersOnly
      digits="35"
      decimals="3"
      autocomplete="off"
      [attr.multiple]="isGetPath"
      [attr.webkitdirectory]="isGetPath"
      [attr.directory]="isGetPath"
      (input)="getInputValue($event.target.value, true)" />
    <div
      #inp
      sepidzAutoFocus
      currency
      [(ngModel)]="inputDataModel.currentValue"
      autocomplete="off"
      tabindex="{{ tabOrder }}"
      class="textinput readonly"
      [class.hasborder]="isshow"
      [class.border]="isshow || labletop"
      [class.showErrorBorder]="group?.controls[name].touched && group?.controls[name]?.invalid && !inputFocus"
      [class.border]="isshow || labletop"
      [class.showErrorBorder]="group?.controls[name].touched && group?.controls[name].invalid && !inputFocus"
      id="{{ name }}"
      [(ngClass)]="class"
      *ngIf="isReadOnly">
      {{ inputDataModel.currentValue }}
    </div>
    <i class="{{ icon }} icon" (click)="onIconClick()" *ngIf="!hasClear"></i>
    <i class="icon-close-o icon" (click)="onClear()" *ngIf="hasClear && inputDataModel.currentValue && !disabled && !isReadOnly"></i>
    <i class="{{ righticon }} txticon" (click)="onRightIconClick()"></i>
    <i class="{{ externalicon }} icon transforicon" (click)="onExternalIconClick()" *ngIf="externalicon"></i>

    <div class="hint unvisible" *ngIf="hint && !group?.controls[name].touched" [class.visible]="hint && !group?.controls[name].touched">
      <span>{{ hint }}</span>
    </div>
    <div
      class="error unvisible"
      *ngIf="name && f[name] && f[name]?.touched && f[name]?.invalid"
      [class.visible]="f[name].touched && f[name]?.invalid">
      <span *ngIf="f[name].errors?.required"> {{ label }} {{ "Errors.Required" | translate }} </span>
      <span [hidden]="!f[name].errors?.pattern"> {{ label }} {{ "Errors.Pattern" | translate }} </span>
      <span
        [hidden]="!f[name].errors?.minlength"
        [tooltip]="('Errors.Minlength' | translate).replace('[0]', label).replace('[1]', min)">
        {{ ("Errors.Minlength" | translate).replace("[0]", label).replace("[1]", min) }}
      </span>
      <span
        [hidden]="!f[name].errors?.maxlength && !f[name].errors?.max"
        [tooltip]="('Errors.Maxlength' | translate).replace('[0]', label).replace('[1]', max ? max : maxLength)">
        {{ ("Errors.Maxlength" | translate).replace("[0]", label).replace("[1]", max ? max : maxLength) }}
      </span>
      <!-- <span
        [hidden]="!f[name].errors?.min && !f[name].errors?.max"
        [tooltip]="('Errors.Length' | translate).replace('[0]', label).replace('[1]', min).replace('[2]', max)">
        {{ ("Errors.Length" | translate).replace("[0]", label).replace("[1]", min).replace("[2]", max) }}
      </span>
      <span
        [hidden]="!f[name].errors?.max && !f[name].errors?.min"
        [tooltip]="('Errors.Length' | translate).replace('[0]', label).replace('[1]', min).replace('[2]', max)">
        {{ ("Errors.Length" | translate).replace("[0]", label).replace("[1]", min).replace("[2]", max) }}
      </span> -->
      <span [hidden]="!f[name].errors?.customerror">
        {{ f[name].errors?.customerror }}
      </span>
    </div>
  </div>
</div>
